import api from './api';

export const searchAll = async (q, types) => {
  const params = new URLSearchParams({ q });
  if (types && types.length > 0) params.set('types', types.join(','));
  const response = await api.get(`/search?${params.toString()}`);
  return response.data;
};

const searchService = { searchAll };
export default searchService;
